import React from 'react';

// MOODIFY PAGE
export const moodifyContent = {
  pageMaxWidth: '1200px',

  breadcrumb: {
    text: 'Back to Home',
    url: '/'
  },

  sections: [
    // HERO
    {
      id: 'hero',
      spacing: 'clamp(24px, 4vw, 48px)',
      blocks: [
        {
          type: 'custom',
          render: () => (
            <img
              src="/C.png"
              alt="Moodify"
              style={{
                height: '80px',
                width: 'auto',
                borderRadius: '8px',
                marginBottom: '16px'
              }}
            />
          )
        },
        {
          type: 'custom',
          render: () => (
            <span style={{
              background: 'linear-gradient(135deg, #00b894 0%, #2d3436 100%)',
              color: 'white',
              padding: '6px 16px',
              borderRadius: '20px',
              fontSize: '12px',
              fontWeight: '600',
              textTransform: 'uppercase',
              letterSpacing: '0.06em',
              display: 'inline-block',
              marginBottom: '16px'
            }}>
              Desktop Tool
            </span>
          )
        },
        { type: 'title', text: 'Moodify', size: 'h1' },
        {
          type: 'text',
          content: 'A desktop moodboard tool. Drop in images, switch grid layouts, pick aspect ratios, and export as PNG, JPEG, PDF, or ZIP. Built for desktop — not a mobile app.',
          size: 'large'
        },
        { type: 'spacer', size: 'small' },
        {
          type: 'custom',
          render: () => (
            <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
              <a
                href="https://www.moodify.so"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  background: 'linear-gradient(135deg, #00b894 0%, #2d3436 100%)',
                  color: 'white',
                  padding: '10px 20px',
                  borderRadius: '8px',
                  textDecoration: 'none',
                  fontWeight: '600',
                  fontSize: '0.9rem'
                }}
              >
                Try Moodify
              </a>
              <span style={{
                background: 'rgba(16, 185, 129, 0.1)',
                color: '#10b981',
                padding: '10px 20px',
                borderRadius: '8px',
                fontWeight: '600',
                fontSize: '0.9rem',
                border: '1px solid rgba(16, 185, 129, 0.3)'
              }}>
                Live
              </span>
            </div>
          )
        }
      ]
    },

    // LIVE EMBED
    {
      id: 'live-demo',
      blocks: [
        {
          type: 'custom',
          render: () => (
            <div style={{
              position: 'relative',
              width: '100%',
              height: '80vh',
              minHeight: '600px',
              background: '#000',
              borderRadius: '16px',
              overflow: 'hidden',
              boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
              border: '1px solid var(--border-color)'
            }}>
              <iframe
                src="https://www.moodify.so/"
                title="Moodify Live"
                style={{
                  width: '100%',
                  height: '100%',
                  border: 'none'
                }}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              />
            </div>
          )
        }
      ]
    },

    // APP SCREENSHOTS
    {
      id: 'screenshots',
      title: 'Inside Moodify',
      blocks: [
        {
          type: 'custom',
          render: () => {
            const screens = [
              { src: '/portfolio-screens/moodify/cover.png', label: 'Light Mode' },
              { src: '/portfolio-screens/moodify/inside.png', label: 'Dark Mode' }
            ];
            return (
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(2, 1fr)',
                gap: '16px',
                maxWidth: '900px',
                margin: '0 auto'
              }}>
                {screens.map((screen, i) => (
                  <div key={i} style={{ textAlign: 'center' }}>
                    <img
                      src={screen.src}
                      alt={screen.label}
                      style={{
                        width: '100%',
                        borderRadius: '16px',
                        border: '1px solid var(--border-color)',
                        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.12)'
                      }}
                    />
                    <p style={{
                      color: 'var(--text-secondary)',
                      fontSize: '0.75rem',
                      marginTop: '8px'
                    }}>
                      {screen.label}
                    </p>
                  </div>
                ))}
              </div>
            );
          }
        }
      ]
    },

    // VIDEOS
    {
      id: 'videos',
      blocks: [
        {
          type: 'custom',
          render: () => {
            const videos = [
              { src: '/moodify-speed.mp4', label: 'Speed' },
              { src: '/moodify-grid.mov', label: 'Grid Layouts' },
              { src: '/moodify-illustrator.mp4', label: 'To Illustrator' },
              { src: '/moodify-email.mov', label: 'Email Export' },
            ];
            return (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
                {videos.map((vid, i) => (
                  <div key={i}>
                    <p style={{
                      color: 'var(--text-secondary)',
                      fontSize: '0.85rem',
                      fontWeight: '600',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em',
                      marginBottom: '10px'
                    }}>
                      {vid.label}
                    </p>
                    <video
                      src={vid.src}
                      controls
                      playsInline
                      preload="metadata"
                      style={{
                        width: '100%',
                        borderRadius: '12px',
                        background: '#000',
                        border: '1px solid var(--border-color)'
                      }}
                    />
                  </div>
                ))}
              </div>
            );
          }
        }
      ]
    },

    // BUILT WITH
    {
      id: 'stack',
      title: 'Built With',
      blocks: [
        {
          type: 'custom',
          render: () => {
            const stack = [
              { name: 'React 19', color: '#61DAFB', bg: 'rgba(97, 218, 251, 0.08)' },
              { name: 'Tailwind CSS', color: '#38BDF8', bg: 'rgba(56, 189, 248, 0.08)' },
              { name: 'Firebase', color: '#FFCA28', bg: 'rgba(255, 202, 40, 0.08)' },
              { name: 'Cloudinary', color: '#3448C5', bg: 'rgba(52, 72, 197, 0.08)' },
              { name: 'html2canvas', color: '#00b894', bg: 'rgba(0, 184, 148, 0.08)' },
              { name: 'jsPDF', color: '#D32F2F', bg: 'rgba(211, 47, 47, 0.08)' },
              { name: 'JSZip', color: '#F9A825', bg: 'rgba(249, 168, 37, 0.08)' },
              { name: 'gif.js', color: '#8B5CF6', bg: 'rgba(139, 92, 246, 0.08)' },
              { name: 'EmailJS', color: '#FC0', bg: 'rgba(255, 204, 0, 0.08)' },
              { name: 'Lodash', color: '#3492FF', bg: 'rgba(52, 146, 255, 0.08)' },
              { name: 'Driver.js', color: '#1DE9B6', bg: 'rgba(29, 233, 182, 0.08)' },
              { name: 'React Router', color: '#CA4245', bg: 'rgba(202, 66, 69, 0.08)' },
            ];
            return (
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                {stack.map((tech) => (
                  <span key={tech.name} style={{
                    background: tech.bg,
                    border: `1px solid ${tech.color}22`,
                    color: tech.color,
                    padding: '10px 20px',
                    borderRadius: '10px',
                    fontSize: '0.9rem',
                    fontWeight: '600',
                    letterSpacing: '0.01em',
                    backdropFilter: 'blur(8px)'
                  }}>{tech.name}</span>
                ))}
              </div>
            );
          }
        }
      ]
    }
  ],

  callToAction: {
    brand: { bg: "linear-gradient(135deg, #12806F 0%, #0B5E52 100%)", fg: "#FFFFFF", btnBg: "#FFFFFF", btnFg: "#0B5E52", titleWeight: 800, titleSpacing: "-0.04em" },
    title: 'Moodify',
    text: 'A desktop moodboard tool',
    button: {
      text: 'Try Moodify',
      url: 'https://www.moodify.so',
      style: 'primary'
    }
  }
};
